import styled from "styled-components";
import {
  ContentTextStyle,
  PageTitleTextStyle,
  RowLayout,
  TitleTextStyle,
} from "common/components";
import { buttonHeight } from "common/const/const";

const LogoImageLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 16vh;
  margin-bottom: 2rem;
  height: 100vh;
  width: 30vw;
  gap: 1.5rem;

  img {
    width: 30%;
  }
`;

const FormLayoutStyle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 80vh;
  height: 80vh;
  width: 40vw;
  gap: 1.5rem;
  margin-top: 5vh;
  margin-bottom: 10vh;
  img {
    width: 8%;
  }
`;

const FieldLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 1rem 0;
  gap: 1.5rem;
  padding-bottom: 50px;
`;

const SignUpWithLogoLayout = ({ title, text, children, style }) => {
  return (
    <FormLayoutStyle
      style={{
        ...style,
      }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "1rem",
          marginBottom: "2rem",
        }}>
        <TitleTextStyle>{title}</TitleTextStyle>
        <div
          style={{
            fontSize: "var(--font-size-20)",
            fontWeight: "var(--font-weight-bold)",
            color: "var(--LightNavy)",
          }}>
          {text}
        </div>
      </div>
      {children}
    </FormLayoutStyle>
  );
};

const PageTitleLayout = ({ title, children }) => {
  return (
    <FormLayoutStyle
      style={{
        alignItems: "flex-start",
        width: "70vw",
      }}>
      <PageTitleTextStyle>{title}</PageTitleTextStyle>
      {children}
    </FormLayoutStyle>
  );
};

const PageTitleWithOutSideBarLayout = ({
  title,
  button,
  children,
  headerStyle,
  flex,
}) => {
  return (
    <FormLayoutStyle
      style={{
        alignItems: "flex-start",
        flex: flex,
      }}>
      <RowLayout
        style={{
          height: buttonHeight,
          minHeight: buttonHeight,
          ...headerStyle,
        }}>
        <PageTitleTextStyle>{title}</PageTitleTextStyle>
        {button}
      </RowLayout>
      <div style={{ width: "100%", paddingBottom: "50px" }}>{children}</div>
    </FormLayoutStyle>
  );
};

export {
  SignUpWithLogoLayout,
  FieldLayout,
  LogoImageLayout,
  PageTitleLayout,
  PageTitleWithOutSideBarLayout,
};
